import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <Header />
            <div className="pt-32 pb-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-[#071028] mb-8">Termos e Condições</h1>

                <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">1. Termos</h2>
                    <p>Ao aceder ao site Marcelo Carvalho Transportes, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis ​​e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">2. Orçamentos</h2>
                    <p>Os orçamentos fornecidos através do site são baseados nas informações fornecidas pelo cliente. Reservamo-nos o direito de ajustar o valor final caso as condições reais da mudança (volume, distância, dificuldades de acesso) sejam diferentes das declaradas.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">3. Responsabilidades</h2>
                    <p>O Marcelo Carvalho Transportes compromete-se a realizar o transporte com o máximo cuidado e profissionalismo. Objetos de valor extremo (joias, dinheiro, documentos) devem ser transportados pelo próprio cliente.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">4. Cancelamentos</h2>
                    <p>Cancelamentos ou reagendamentos devem ser comunicados com a maior antecedência possível através dos nossos canais de contacto oficiais (WhatsApp ou Telefone).</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">5. Alterações</h2>
                    <p>O Marcelo Carvalho Transportes pode revisar estes termos de serviço do site a qualquer momento, sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de serviço.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsOfService;
